module.exports = __webpack_public_path__ + "img/water_recovered.a59c515c.png";